export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20creative%20workspace%20with%20a%20laptop%20screen%20displaying%20colorful%20spreadsheet%20product%20catalog%20with%20product%20thumbnails%20warm%20natural%20morning%20light%20coming%20through%20a%20window%20cozy%20minimalist%20desk%20setup%20with%20a%20notebook%20and%20a%20steaming%20coffee%20cup%20soft%20terracotta%20and%20sage%20green%20accents%20Scandinavian%20inspired%20interior%20with%20a%20small%20potted%20plant%20clean%20editorial%20photography%20with%20relaxed%20atmosphere&width=800&height=600&seq=kakobuy-about-img-v2&orientation=landscape"
                alt="Kakobuy Spreadsheet - nowoczesny katalog online"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-4 left-4 flex gap-2">
                <span className="px-3 py-1 rounded-full bg-white/80 backdrop-blur-sm text-foreground-800 text-xs font-medium">2026</span>
                <span className="px-3 py-1 rounded-full bg-white/80 backdrop-blur-sm text-foreground-800 text-xs font-medium">Aktualizowane</span>
                <span className="px-3 py-1 rounded-full bg-white/80 backdrop-blur-sm text-foreground-800 text-xs font-medium">SEO Friendly</span>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-5">
              Co to jest Kakobuy Spreadsheet?
            </h2>

            <div className="flex flex-wrap gap-2 mb-6">
              <span className="px-3 py-1 rounded-full border border-accent-300/60 text-accent-700 text-xs font-medium">Katalog</span>
              <span className="px-3 py-1 rounded-full text-foreground-600 text-xs font-medium">Poradnik</span>
              <span className="px-3 py-1 rounded-full text-foreground-600 text-xs font-medium">Społeczność</span>
            </div>

            <div className="bg-foreground-900 rounded-2xl p-6 md:p-8">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs font-medium mb-4">
                Dlaczego my?
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
                Najlepszy katalog w Polsce
              </h3>
              <p className="text-background-200/80 text-sm leading-relaxed mb-4">
                Kakobuy Spreadsheet to starannie przygotowany katalog produktów, aktualizowany codziennie przez nasz zespół. Każdy produkt jest weryfikowany, a kategorie są przejrzyście posegregowane, abyś mógł szybko znaleźć to, czego potrzebujesz.
              </p>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 md:w-12 md:h-12 flex-shrink-0 rounded-xl overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20a%20premium%20leather%20fashion%20accessory%20with%20gold%20hardware%20details%20on%20soft%20warm%20peach%20linen%20background%20soft%20natural%20lighting%20from%20window%20clean%20elegant%20aesthetic%20warm%20neutral%20tones%20with%20subtle%20rose%20gold%20reflections%20editorial%20luxury%20product%20style&width=120&height=120&seq=kakobuy-thumb-v2&orientation=squarish"
                    alt="Produkt Kakobuy"
                    className="w-full h-full object-cover"
                  />
                </span>
                <p className="text-background-300/70 text-xs">
                  Ponad 5000+ produktów w 14 kategoriach, codzienne aktualizacje i wsparcie społeczności.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}